"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Artisanal Coffee & Matcha",
  description: "Experience the perfect pour with our locally roasted beans and premium ceremonial grade matcha. Each cup is crafted with precision to bring out the delicate notes of our signature blends."
}, {
  title: "Focaccia Deli Sandwiches",
  description: "Our focaccia is sourced fresh from a trusted local bakery, serving as the golden, herb-crusted foundation for our gourmet deli selections. A true taste of European tradition right here in Enfield."
}, {
  title: "Imported European Market",
  description: "Browse our curated selection of specialty grocery items sourced directly from Europe. From fine oils to unique sweets, we bring the flavors of the continent to your neighborhood pantry."
}];
export default function SeasonalSipsBites() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264571" id="seasonal-sips-bites" className="dark bg-background text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24 relative overflow-hidden" ref={sectionRef}>
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.05] pointer-events-none" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_auto_1.5fr] gap-12 lg:gap-20 relative z-10">
        
        {}
        <div className={`flex flex-col justify-start lg:sticky lg:top-32 h-fit transition-all duration-1000 transform ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight leading-tight">
            Seasonal <br className="hidden lg:block" />
            <span className="text-primary">Sips & Bites</span>
          </h2>
          <p className="mt-6 text-muted-foreground text-lg max-w-md font-sans">
            Discover the warm, modern flavors of M&M Café & Market. We blend artisanal craftsmanship with the finest European ingredients.
          </p>
        </div>

        {}
        <div className="hidden lg:flex justify-center">
          <Separator orientation="vertical" className={`h-full min-h-[500px] bg-border/20 transition-all duration-1000 delay-300 ${isSectionVisible ? "opacity-100 h-full" : "opacity-0 h-0"}`} />
        </div>
        <div className="block lg:hidden w-full">
          <Separator orientation="horizontal" className="w-full bg-border/20" />
        </div>

        {}
        <div className="flex flex-col gap-20 lg:gap-32 pt-8 lg:pt-0">
          {features.map((feature, i) => <FeatureBlock key={i} index={i} title={feature.title} description={feature.description} />)}
        </div>
      </div>
    </section>;
}
function FeatureBlock({
  index,
  title,
  description
}: {
  index: number;
  title: string;
  description: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const numberString = `0${index + 1}`;
  return <div data-index={index} ref={ref} className={`relative group transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      {}
      <span className="absolute -top-12 -left-4 md:-top-16 md:-left-8 text-8xl md:text-[10rem] font-default font-bold text-primary/10 select-none transition-colors duration-500 group-hover:text-primary/20 z-0 leading-none tracking-tighter">
        {numberString}
      </span>

      {}
      <div className="relative z-10 pl-4 md:pl-8 border-l-2 border-transparent group-hover:border-primary/40 transition-colors duration-500">
        <h3 className="text-2xl md:text-3xl font-default font-semibold mb-4 text-foreground tracking-tight">
          {title}
        </h3>
        <p className="text-muted-foreground text-lg leading-relaxed font-sans max-w-xl">
          {description}
        </p>
      </div>
    </div>;
}